<template>
  <i-modal class="modal-happy_call" v-model="modal" @on-visible-change="onVisibleChange" title="物件確認" width="640">
    <div>
      <i-form label-position="left" :label-width="96">
        <i-row>
          <i-col span="12">
            <i-form-item label="価格">
              <InputNumber :value.sync="formItem.b_price_low" :width="160" />
              万円
            </i-form-item>
          </i-col>
          <i-col span="12">
            <i-form-item label="販売状態">
              <i-select v-model="formItem.mi_sale_state_cd" clearable style="width: 160px;">
                <template v-for="(item, idx) in master.sale_state">
                  <i-option :key="`saleState${idx}`" :value="Number(item.cd)">{{ item.label }}</i-option>
                </template>
              </i-select>
            </i-form-item>
          </i-col>
        </i-row>
        <i-row>
          <i-col span="12">
            <i-form-item label="現況">
              <i-select v-model="formItem.m_vacant_type_id" clearable style="width: 160px;">
                <template v-for="(item, idx) in selVacantType">
                  <i-option :key="`selVacantType${idx}`" :value="Number(item.cd)">{{ item.label }}</i-option>
                </template>
              </i-select>
            </i-form-item>
          </i-col>
        </i-row>
        <i-row>
          <i-col span="24">
            <i-form-item label="引き渡し時期">
              <i-select v-model="formItem.delivery_term_y" clearable style="width: 160px; margin-right: 8px;">
                <template v-for="(item, idx) in masterYear">
                  <template v-if="item.value >= 1970 && item.value <= new Date().getFullYear()">
                    <i-option :key="`deliveryTermY${idx}`" :value="Number(item.value)">{{ item.label }}</i-option>
                  </template>
                </template>
              </i-select>
              <span style="margin-right: 8px;">年</span>
              <i-select v-model="formItem.delivery_term_m" clearable style="width: 80px;  margin-right: 8px;">
                <template v-for="month in 12">
                  <i-option :key="`deliveryTermM${month}`" :value="month">{{ month }}</i-option>
                </template>
              </i-select>
              <span style="margin-right: 8px;">月</span>
              <i-select v-model="formItem.delivery_term_d" clearable style="width: 80px; margin-right: 8px;">
                <template v-for="day in 31">
                  <i-option :key="`deliveryTermD${day}`" :value="day">{{ day }}</i-option>
                </template>
              </i-select>
              <span style="margin-right: 8px;">日</span>
              <BtnDatePicker :value.sync="dateCalendarDeliveryTerm" style="display: inline-block;" />
            </i-form-item>
          </i-col>
        </i-row>
        <i-row>
          <i-col span="24">
            <i-form-item label="確認日">
              <i-select v-model="formItem.confirm_y" clearable style="width: 160px; margin-right: 8px;">
                <template v-for="(item, idx) in masterYear">
                  <template v-if="item.value >= 1970 && item.value <= new Date().getFullYear()">
                    <i-option :key="`confirmY${idx}`" :value="Number(item.value)">{{ item.label }}</i-option>
                  </template>
                </template>
              </i-select>
              <span style="margin-right: 8px;">年</span>
              <i-select v-model="formItem.confirm_m" clearable style="width: 80px;  margin-right: 8px;">
                <template v-for="month in 12">
                  <i-option :key="`confirmM${month}`" :value="month">{{ month }}</i-option>
                </template>
              </i-select>
              <span style="margin-right: 8px;">月</span>
              <i-select v-model="formItem.confirm_d" clearable style="width: 80px; margin-right: 8px;">
                <template v-for="day in 31">
                  <i-option :key="`confirmD${day}`" :value="day">{{ day }}</i-option>
                </template>
              </i-select>
              <span style="margin-right: 8px;">日</span>
              <BtnDatePicker :value.sync="dateCalendarConfirmDate" style="display: inline-block;" />
            </i-form-item>
          </i-col>
        </i-row>
        <i-row>
          <i-col span="24">
            <i-form-item label="業者名">
              <i-select v-model="formItem.ea_id" clearable @on-change="onChangeEa" style="width: 240px;">
                <template v-for="(item, i) in eaList">
                  <i-option :key="`ea${i}`" :value="item.id">{{ item.company_name }}</i-option>
                </template>
              </i-select>
            </i-form-item>
          </i-col>
        </i-row>
        <i-row>
          <i-col span="24">
            <i-form-item label="担当者・連絡先">
              <i-select
                v-model="formItem.um_eachargeperson_id"
                clearable
                style="width: 240px;"
                :disabled="!eaChargeParsonList.length"
              >
                <template v-for="(item, i) in eaChargeParsonList">
                  <template v-if="item.charge_person_name">
                    <i-option :key="`eaChargeParson${i}`" :value="item.id">{{ item.charge_person_name }}</i-option>
                  </template>
                </template>
              </i-select>
              <span style="margin-left: 8px;">TEL：{{ eaParsonTel }}</span>
            </i-form-item>
          </i-col>
        </i-row>
      </i-form>
    </div>
    <div slot="footer">
      <i-button type="primary" @click="onClickSave">保存</i-button>
    </div>
  </i-modal>
</template>

<script>
import { Modal, Row, Col, Form, FormItem, Select, Option, Button } from 'view-design'
import InputNumber from '@/components/parts/InputNumber'
import BtnDatePicker from '@/components/parts/BtnDatePicker'
import EaCompanyRepository from '@/repositories/eaCompanyRepository'
import BukkenRepository from '@/repositories/bukkenRepository'
import Common from '@/mixins/common'
export default {
  mixins: [Common],
  components: {
    'i-modal': Modal,
    'i-row': Row,
    'i-col': Col,
    'i-form': Form,
    'i-form-item': FormItem,
    'i-select': Select,
    'i-option': Option,
    'i-button': Button,
    InputNumber,
    BtnDatePicker,
  },
  computed: {
    modal: {
      get() {
        return this.$store.getters['ModalHappyCall/getModal']
      },
      set(val) {
        this.$store.commit('ModalHappyCall/setModal', val)
      },
    },
    id() {
      return this.$store.getters['ModalHappyCall/getId']
    },
    mBTypeId() {
      return this.$store.getters['ModalHappyCall/getMBTypeId']
    },
    formItem: {
      get() {
        return this.$store.getters['ModalHappyCall/getFormItem']
      },
      set(val) {
        this.$store.commit('ModalHappyCall/setFormItem', val)
      },
    },
    master() {
      return this.$store.getters['Master/getMaster']
    },
    masterYear() {
      return this.$store.getters['Master/getYear']
    },
    property: {
      get() {
        return this.$store.getters['Property/getProperty']
      },
      set(val) {
        this.$store.commit('Property/setProperty', val)
      },
    },
    // 現況プルダウン
    selVacantType() {
      let selVacantType = []
      if (this.mBTypeId && this.master.vacant_type) {
        const mBTypeId = String(_.cloneDeep(this.mBTypeId))
        const idx = mBTypeId ? mBTypeId.slice(0, 2) : null
        selVacantType = idx ? this.master.vacant_type[idx] : []
      }
      return selVacantType
    },
    // 担当者TEL 表示処理
    eaParsonTel() {
      let tel = ''
      const id = this.formItem.um_eachargeperson_id
      const selectParson = _.find(this.eaChargeParsonList, { id: id })
      if (selectParson) tel = selectParson.charge_person_tel
      return tel
    },
  },
  data() {
    return {
      dateCalendarDeliveryTerm: '',
      dateCalendarConfirmDate: '',
      eaList: [],
      eaChargeParsonList: [],
    }
  },
  watch: {
    dateCalendarDeliveryTerm(val) {
      if (val) {
        const ymd = new Date(val).toLocaleDateString().split('/')
        this.formItem.delivery_term_y = Number(ymd[0])
        this.formItem.delivery_term_m = Number(ymd[1])
        this.formItem.delivery_term_d = Number(ymd[2])
      }
    },
    dateCalendarConfirmDate(val) {
      if (val) {
        const ymd = new Date(val).toLocaleDateString().split('/')
        this.formItem.confirm_y = Number(ymd[0])
        this.formItem.confirm_m = Number(ymd[1])
        this.formItem.confirm_d = Number(ymd[2])
      }
    },
  },
  methods: {
    // モーダル開閉時処理
    onVisibleChange(isOpen) {
      if (isOpen) {
        // モーダル起動処理
        this.getEaList()
        if (this.formItem.ea_id) this.getEaChargeParson(this.formItem.ea_id)
      } else {
        setTimeout(this.resetParams, 300)
      }
    },
    // 元付業者変更処理
    onChangeEa(id) {
      this.formItem.um_eachargeperson_id = null
      if (id) {
        this.getEaChargeParson(id)
      } else {
        this.eaChargeParsonList = []
      }
    },

    // 保存ボタン クリック処理
    onClickSave() {
      const params = {}
      _.forEach(this.formItem, function(val, key) {
        if (_.isUndefined(val)) val = null
        params[key] = val
      })
      this.patchHappyCall(params)
    },
    // 物件確認更新処理
    async patchHappyCall(params) {
      this.$store.dispatch('Loading/setLoading', true)
      await BukkenRepository.patchHappyCall(this.id, params)
        .then(res => {
          if (res.result) {
            // 物件一覧に反映
            const propertyId = this.id
            const property = _.find(this.property, function(item) {
              return item.id === propertyId
            })
            property.b_price_low = params.b_price_low
            property.mi_sale_state_cd = params.mi_sale_state_cd
            property.m_vacant_type_id = params.m_vacant_type_id
            property.delivery_term_y = params.delivery_term_y
            property.delivery_term_m = params.delivery_term_m
            property.delivery_term_d = params.delivery_term_d
            property.confirm_y = params.confirm_y
            property.confirm_m = params.confirm_m
            property.confirm_d = params.confirm_d
            property.ea_id = params.ea_id
            property.um_eachargeperson_id = params.um_eachargeperson_id
            const vacantTypeItem = _.find(this.selVacantType, { cd: params.m_vacant_type_id })
            property._vacant_type = vacantTypeItem ? vacantTypeItem.label : ''
            const saleStateItem = _.find(this.master.sale_state, { cd: params.mi_sale_state_cd })
            property._sale_state = saleStateItem ? saleStateItem.label : ''
            property._confirm_date = this.get_ConfirmDate(params.confirm_y, params.confirm_m, params.confirm_d)
            property._ea_name = this.get_eaName(params.ea_id)
            property._ea_charge_parson = this.get_eaChargeParson(params.um_eachargeperson_id)

            alert('物件情報を更新しました。')
          } else {
            alert('物件情報の更新に失敗しました。')
          }
        })
        .catch(e => {
          console.log(e)
          alert('物件情報の更新に失敗しました。')
        })
        .finally(() => {
          this.$store.dispatch('Loading/setLoading', false)
          this.modal = false
        })
    },
    // 表示用元付け業者名
    get_eaName(eaId) {
      let eaName = '-'
      if (eaId) {
        const ea = _.find(this.eaList, { id: eaId })
        eaName = ea.company_name
      }
      return eaName
    },
    // 表示用業者名・連絡先
    get_eaChargeParson(id) {
      let eaChargeParson = '-'
      if (id) {
        const chargeParson = _.find(this.eaChargeParsonList, { id: id })
        eaChargeParson = `${this.formatText(chargeParson.charge_person_name)}・${this.formatText(
          chargeParson.charge_person_tel,
        )}`
      }
      return eaChargeParson
    },
    // 表示用確認日
    get_ConfirmDate(y, m, d) {
      let confirmDate = '-'
      if (y && m && d) {
        confirmDate = `${y}/${('00' + this.formatText(m)).slice(-2)}/${('00' + this.formatText(d)).slice(-2)}`
      }
      return confirmDate
    },
    // 元付け業者一覧を取得
    async getEaList() {
      await EaCompanyRepository.get()
        .then(res => {
          if (res.result) {
            this.eaList = res.data.data
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    // 元付け業者 担当者一覧を取得
    async getEaChargeParson(id) {
      await EaCompanyRepository.getOne(id)
        .then(res => {
          if (res.result) {
            this.eaChargeParsonList = res.data.ea_charge_persons
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    // パラメータリセット
    resetParams() {
      // iviewモーダルが起動された際、bodyに付与されるstyle`overflow:hidden`が残るケースがあるので、
      // 動的にvisibleを付与する
      const bodyElement = document.getElementById('top')
      bodyElement.style.overflow = 'visible'

      // パラメータリセット
      this.dateCalendarDeliveryTerm = ''
      this.dateCalendarConfirmDate = ''
      this.$store.dispatch('ModalHappyCall/reset')
    },
  },
}
</script>

<style lang="scss">
.modal-happy_call {
  .ivu-form .ivu-form-item-label {
    font-weight: bold;
  }
}
</style>
